import useReveal from "./useReveal";
import { FAQ_ITEMS } from "./faqData";

const Faq = () => {
    const [ref, visible] = useReveal();
    return (
        <section
            className={`sect sect--soft reveal${visible ? " is-in" : ""}`}
            id="faq"
            ref={ref}
        >
            <div className="wrap wrap--narrow">
                <div className="sect__head">
                    <span className="eyebrow">Вопросы и ответы</span>
                    <h2 className="sect__title">Что обычно спрашивают перед стартом</h2>
                </div>
                <div className="faq">
                    {FAQ_ITEMS.map((item) => (
                        <details className="faq__i" key={item.q}>
                            <summary>{item.q}</summary>
                            <div>
                                <p>{item.a}</p>
                            </div>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Faq;
